import { render, staticRenderFns } from "./comparative-content.vue?vue&type=template&id=2e59dc30&"
import script from "./comparative-content.ts?vue&type=script&lang=ts&"
export * from "./comparative-content.ts?vue&type=script&lang=ts&"
import style0 from "./comparative-content.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports